<template>
<div>
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>
    <div class="page_content_box">
        <div class="wrap">

            <div class="detail">
                <div class="desc">
                    <div class="text_left">
                        <h1>{{content.enterpriseName}}--{{content.jobVacancy}}</h1>
                        <div class="salary"><h2>{{content.salaryRange}}</h2><span>{{options[content.education]}}</span><span>{{content.workYears}}</span></div>
                    </div>
                    <div class="btn" @click="dialogFormVisible = true">投递简历</div>
                </div>
                <div class="box">
                    <div class="content_left">
                        <h3>招聘职位</h3>
                        <div class="con">
                            <p>{{content.jobVacancy}}</p>
                        </div>
                        <h3>招聘人数</h3>
                        <div class="con">
                            <p>{{content.jobNum}}</p>
                        </div>
                        <h3>工作地点</h3>
                        <div class="con">
                            <p>{{content.workAddress}}</p>
                        </div>
                        <h3>薪资范围</h3>
                        <div class="con">
                            <p>{{content.salaryRange}}</p>
                        </div>
                        <h3>岗位职责</h3>
                        <div class="con">
                            {{content.responsibility}}
                        </div>
                        <h3>任职要求</h3>
                        <div class="con">
                            {{content.jobSpecification}}
                        </div>
                        <h3>福利待遇</h3>
                        <div class="con">
                            {{content.welfareTreatment}}
                        </div>
                    </div>
                    <div class="content_right">
                        <div class="company">
                            <h3>{{content.enterpriseName}}</h3>
                            <div class="intro">{{content.companyIntroduction}}</div>
                            <h4>联系人</h4>
                            <p>{{content.contactName}}</p>
                            <h4>联系方式</h4>
                            <p>{{content.mobile}}</p>
                            <h4>联系邮箱</h4>
                            <p>{{content.contactMail}}</p>
                        </div>
                        <div class="position_info">
                            <h3>推荐岗位</h3>
                            <div class="info_box">
                                <div class="info" v-for="(item,index) in recruitmentInfo" :key="index">
                                    <router-link :to="'/recruitDetail/'+item.id">
                                        <h5>{{item.jobVacancy}}</h5>
                                        <div class="flag"><span>{{item.workAddress}}</span><span>{{item.workYears}}</span></div>
                                        <div class="salary">{{item.salaryRange}}</div>
                                        <p>{{item.enterpriseName}}</p>
                                    </router-link>
                                    <span class="stop" v-if="item.state===4?true:false">停止招聘</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>

    <!-- dialog 投递简历 -->
    <el-dialog title="投递简历" :visible.sync="dialogFormVisible" class="delivery_dialog">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="login_form">
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="ruleForm.mobile" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码" class="verCode_item" prop="code">
          <el-input v-model="ruleForm.code" placeholder=""></el-input>
          <div class="getCode" v-show="!dCount.showCountDown" @click="getCode">获取验证码</div>
          <div class="countDown" v-show="dCount.showCountDown">{{ dCount.count }}秒后重新获取</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
import {
  getRecruitmentDetail,
  getRecruitmentPage,
  getSmsCode,
  createDelivery,
  getUserInfo,
  smsLogin
} from '@/service/api.js'
import {dateFormat, createContentMeta} from '@/utils/util.js'
import {encrypt} from "../../utils/jsencrypt";

export default {
  // components: { TopMenu,TopBar,Footer,TopSlider },
  components: { TopMenu,Footer,TopSlider },
    data() {
        // 验证手机号
        let vPhone = (rule, value, callback) => {
            const reg = /^1[3|4|5|7|8|6|9]\d{9}$/
            if (reg.test(value)) {
            callback()
            } else {
            return callback(new Error('请输入正确的手机号'))
            }
        }
        return {
            currentIndex: 99,
            content:{},
            dialogFormVisible:false,
            salaryRangeOptions:{
                0:"面议",
                1:"3000以下",
                2:"3000-5000",
                3:"5000-9000",
                4:"9000以上",
            },
            workYearsOptions:{
                0:"不限",
                1:"1-3年",
                2:"3-5年",
                3:"5-10年",
                4:"10年以上",
            },
          options: {
            "1": "小学",
            "2": "初中",
            "3": "高中",
            "4": "专科",
            "5": "本科",
            "6": "硕士",
            "7": "博士",
          }, enterpriseTypeOptions:{
            "1": "企业",
            "2": "社团",
            "3": "机关事业单位",
            "4": "个体工商户"
          },
            recruitmentInfo:[],
            dCount:{
                showCountDown:false,
                count:'',
                timer:null,
            },
            ruleForm:{
                mobile:'',
                code:'',
                recruitmentInfoId:''
            },
            rules:{
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: vPhone, required: true, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
            }
        }
    },
    mounted () {
        getRecruitmentDetail(this.$route.params.id).then(data=>{
            console.log(data);
            if (data.code !==0) {
                this.$message.error(data.msg)
            }else{
                this.content = data.data
                this.content.pushTime = dateFormat(this.content.pushTime,'Y年M月D日')
                this.content.salaryRange = this.salaryRangeOptions[this.content.salaryRange]
                this.content.workYears = this.workYearsOptions[this.content.workYears]
                // this.content.education = this.options[this.content.education]
                getRecruitmentPage({pageNo:1,pageSize:10,enterpriseId:data.data.enterpriseId}).then(data=>{
                    console.log(data);
                    if (data.code===0) {
                        this.recruitmentInfo = data.data.list
                        this.recruitmentInfo.forEach(el => {
                            el.salaryRange = this.salaryRangeOptions[el.salaryRange]
                            el.workYears = this.workYearsOptions[el.workYears]
                            el.education = this.options[el.education]
                        });
                    }else{
                        this.$message.error(data.msg)
                    }
                })
                // 添加meta标签
                let temp = {
                  'ColumnName': '求职招聘',
                  'ColumnType': '求职招聘',
                  'ArticleTitle': this.content.enterpriseName,
                  'PubDate': this.content.pushTime,
                  'ContentSource': '海淀区退役军人事务局',
                  'Author': '海淀区退役军人事务局'
                }
                createContentMeta(temp)
            }
        });
    },
    beforeCreate () {
    },
    methods: {
        // 获取验证码
        getCode(){
            this.$refs.ruleForm.validateField('mobile',(error) => {
                if (error) {
                    console.log('mobile',error);
                }else{
                    const TIME_COUNT = 60;
                    if (!this.dCount.timer) {
                        this.dCount.count = TIME_COUNT;
                        this.dCount.showCountDown = true;
                        this.dCount.timer = setInterval(() => {
                            if (this.dCount.count > 0 && this.dCount.count <= TIME_COUNT) {
                                this.dCount.count--;
                            } else {
                                this.dCount.showCountDown = false;
                                clearInterval(this.dCount.timer);
                                this.dCount.timer = null;
                            }
                        }, 1000)
                    }
                    getSmsCode({mobile:encrypt(''+this.ruleForm.mobile)}).then(data=>{
                        console.log(data);
                    })
                }
            })
        },
        // 登录
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                  let token;
                    smsLogin(this.ruleForm).then(data=>{
                        if (data.code !==0) {
                            this.$message.error(data.msg)
                        }else {
                            if (data.token) {
                                localStorage.setItem('token',data.token)
                                token=data.token;
                                getUserInfo().then(data=>{
                                    if (data.code !== 0 ) {
                                        this.$message.error(data.msg)
                                    }else{
                                        this.$store.commit('setUserInfo',data.data)

                    // 区分企业用户和个人用户
                    if (data.data.certification) {
                      this.dialogFormVisible = false
                      this.$message.error('企业用户不能投递简历')
                    } else {
                      this.ruleForm.recruitmentInfoId = this.$route.params.id
                      createDelivery(this.ruleForm).then(data => {
                        console.log(data);
                        if (data.code === 1114) {
                          localStorage.setItem('token', token)
                          this.$router.push({name: 'PersonalResume'})
                          this.$message.error(data.msg)
                          return
                        }
                        if (data.code !== 0) {
                          this.$message.error(data.msg)
                        } else {
                          if (token) {
                            this.$message.success('投递成功')
                            localStorage.setItem('token', token)
                          }
                        }

                      })

                      this.dialogFormVisible = false
                    }
                  }

                })
              }
              console.log(this.$store.state.userInfo);
            }
          })


          // this.ruleForm.recruitmentInfoId = this.$route.params.id
          // createDelivery(this.ruleForm).then(data=>{
          //     console.log(data);
          //     if (data.code===1114) {
          //         localStorage.setItem('token',data.token)
          //         this.$router.push({name:'PersonalResume'})
          //         this.$message.error(data.msg)
          //         return
          //     }
          //     if (data.code !==0) {
          //         this.$message.error(data.msg)
          //     }else {
          //         if (data.token) {
          //             localStorage.setItem('token',data.token)
          //         }
          //         this.$message.success('投递成功')
          //         this.dialogFormVisible=false
          //     }

          // })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  watch: {
    '$route'(to, from) {
      console.log(to, from);
      if (to.fullPath !== from.fullPath) {
        this.$router.push({path: to.fullPath})
        location.reload()
      }

    },
  },
}
</script>
<style lang="less">
.delivery_dialog {
  .el-dialog {
    width: 500px;
  }
}
</style>
<style lang="less" scoped>
.delivery_dialog {
  .getCode {
    width: 110px;
    height: 40px;
    text-align: center;
    border: solid 1px #DDD;
    background-color: #FFF;
    color: #333;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;
  }

  .countDown {
    width: 110px;
    height: 40px;
    text-align: center;
    border: solid 1px #DDD;
    background-color: rgb(218, 218, 218);
    color: #333;
    border-radius: 5px;
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
    margin-left: 20px;
  }

  .verCode_item {
    .el-input {
      width: 250px;
    }
  }
}

.detail {
  padding: 0 0 50px;
  overflow: hidden;
  min-height: 600px;

  .desc {
    background-color: #f7f9ff;
    padding: 30px;
    position: relative;
    overflow: hidden;

    .text_left {
      width: 950px;
      overflow: hidden;
      float: left;

      h1 {
        font-size: 24px;
        font-weight: 600;
        line-height: 1.4;
      }

      .salary {
        margin-top: 10px;

        h2 {
          font-size: 18px;
          color: #fc703e;
          font-weight: 600;
          display: inline-block;
        }

        span {
          display: inline-block;
          background-color: #edf1fb;
          font-size: 14px;
          color: #999;
          padding: 3px 10px;
          margin-left: 10px;
        }
      }
    }

    .btn {
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #FFF;
      font-weight: 600;
      background-color: #18388b;
      border-radius: 20px;
      float: right;
      margin-right: 10px;
    }
  }

  .box {
    overflow: hidden;
    padding: 40px 20px;

    .content_left {
      width: 740px;
      float: left;

      h3 {
        font-weight: 600;
      }

      .con {
        margin: 10px 0 20px 0;
        line-height: 1.6;
      }
    }

    .content_right {
      width: 420px;
      float: right;
      border-left: solid 1px #f3f3f3;
      padding-left: 20px;

      .company {
        h3 {
          font-weight: 600;
          text-align: center;
        }

        .intro {
          text-align: justify;
          line-height: 1.6;
          margin-top: 20px;
        }

        h4 {
          font-weight: 600;
          margin-top: 20px;
        }

        p {
          margin-top: 10px;
        }
      }

      .position_info {
        margin-top: 30px;

        h3 {
          font-weight: 600;
          color: #18388b;
          font-size: 18px;
          position: relative;

          &::after {
            content: '';
            width: 320px;
            height: 1px;
            background-color: #e8e8e8;
            position: absolute;
            right: 0;
            top: 50%;
          }
        }

        .info_box {
          width: 379px;
          height: 370px;
          overflow: auto;
          box-sizing: border-box;

          .info {
            background-color: #f8faff;
            padding: 10px 20px;
            margin-top: 15px;
            position: relative;

            h5 {
              font-weight: 600;
            }

            .flag {
              margin-top: 10px;

              span {
                display: inline-block;
                background-color: #edf2fb;
                font-size: 14px;
                color: #999;
                padding: 3px 10px;
                margin-right: 10px;
              }
            }

            p {
              margin-top: 10px;
            }

            .stop {
              width: 100px;
              height: 30px;
              background-color: #f1f1f1;
              border-radius: 15px;
              text-align: center;
              line-height: 30px;
              color: #999;
              position: absolute;
              top: 10px;
              right: 10px;
            }
          }
        }
      }
    }
  }

  .file {
    margin-top: 20px;

    h2 {
      font-weight: 600;
    }

    ul {
      padding-left: 2em;

      li {
        line-height: 1;
        margin-top: 10px;

        a {
          color: #18388b;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
